<template>
    <sl-card>
        <template v-if="!isFetching">
            <h3 slot="header">{{ entity?.name }}</h3>
            <img
                slot="image"
                id="thumbnail"
                v-if="entity?.thumbnail"
                :src="entity?.thumbnail"
                alt="thumbnail"
            />
            <p v-if="entity?.short_description" class="body">
                {{ entity?.short_description }}
            </p>
            <div slot="footer" class="path">
                <span v-if="domain" class="segment">
                    <i class="pi pi-cloud"></i>
                    <span>{{ domain.name }}</span>
                </span>
                <span v-if="role" class="segment">
                    <i class="pi pi-chevron-right"></i>
                    <i class="pi pi-id-card"></i>
                    <span>{{ role.name }}</span>
                </span>
                <span v-if="businessEntity" class="segment">
                    <i class="pi pi-chevron-right"></i>
                    <i class="pi pi-building"></i>
                    <span>{{ businessEntity.name }}</span>
                </span>
                <span v-if="product" class="segment">
                    <i class="pi pi-chevron-right"></i>
                    <i class="pi pi-box"></i>
                    <span>{{ product.name }}</span>
                </span>
                <span v-if="process" class="segment">
                    <i class="pi pi-chevron-right"></i>
                    <i class="pi pi-share-alt"></i>
                    <span>{{ process.name }}</span>
                </span>
                <span v-if="task" class="segment">
                    <i class="pi pi-chevron-right"></i>
                    <i class="pi pi-check-square"></i>
                    <span>{{ task.name }}</span>
                </span>
            </div>
        </template>
        <template v-else>
            <sl-skeleton slot="header" effect="sheen"></sl-skeleton>
            <p class="body">
                <sl-skeleton effect="sheen"></sl-skeleton>
                <sl-skeleton effect="sheen"></sl-skeleton>
            </p>
        </template>
    </sl-card>
</template>

<script setup lang="ts">
import "@shoelace-style/shoelace/dist/themes/light.css";
import "@shoelace-style/shoelace/dist/themes/dark.css";
import "@shoelace-style/shoelace/dist/components/card/card.js";
import "@shoelace-style/shoelace/dist/components/skeleton/skeleton.js";
import { useEntityManager, EntityType } from "@/stores/entity-store";

const props = defineProps<{
    entityId: string;
    entityType: EntityType;
}>();

const {
    isFetching,
    entity,
    businessEntity,
    task,
    process,
    product,
    domain,
    role,
} = useEntityManager(props.entityType, props.entityId);
</script>

<style scoped lang="scss">
sl-card {
    width: 32em;
    max-width: 400px;

    &::part(body) {
        display: contents;
    }
}

.path {
    display: flex;
    align-items: center;
    gap: 0.25rem;
    font-size: 0.85rem;
    flex-wrap: wrap;

    .pi-chevron-right {
        font-size: 0.5rem;
    }
}

.segment {
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
    flex-wrap: nowrap;
    white-space: nowrap;
}

.body {
    padding: var(--padding);
    max-height: 500px;
    overflow-y: scroll;
}

sl-skeleton {
    width: 300px;
}

p sl-skeleton {
    &:not(:last-of-type) {
        margin-bottom: 1rem;
    }

    &:last-of-type {
        width: 250px;
    }
}

//thumbnail styling
#thumbnail {
    max-height: 200px;
    object-fit: contain;
}
</style>
